import React from 'react';
import "./portfolio.css"
import Home from "./home.js"

function Portfolio() {
    return (
        <div className="background-image container portfolio">
            <div className='content'>
                <Home />
            </div>
        </div>
        );
}

export default Portfolio